import React, { useState } from "react";
import "./Navbar.scss";
import { images } from "../../constants/index";

import { HiMenuAlt4, HiXCircle } from "react-icons/hi";
import { motion } from "framer-motion";

import pdf from "../../assets/AbhijitSingha.pdf";

const Navbar = () => {
  const [toggle, setToggle] = useState(false);
  return (
    <nav className="app__navbar">
      <div className="app__navbar-logo">
        <img src={images.logo} alt="logo" />
      </div>
      <ul className="app__navbar-links">
        {["home", "about", "skills", "work", "contact"].map((item) => (
          <li className="app__flex p-text" key={`link-${item}`}>
            <div />
            <a href={`#${item}`}>{item}</a>
          </li>
        ))}
        <li className="app__flex p-text">
          <div />
          <a href={pdf} target="_blank">
            RESUME
          </a>
        </li>
      </ul>
      <div className="app__navbar-menu">
        <HiMenuAlt4 onClick={() => setToggle(true)} />
        {toggle && (
          <motion.div
            whileInView={{ y: [-200, 0] }}
            transition={{ duration: 0.8, ease: "easeOut" }}
          >
            <HiXCircle
              className="cross__menu"
              onClick={() => setToggle(false)}
            />
            <ul>
              {["home", "about", "skills", "work", "contact"].map((item) => (
                <li key={item}>
                  <a href={`#${item}`} onClick={() => setToggle(false)}>
                    {item}
                  </a>
                </li>
              ))}
              <li>
                <a href={pdf} target="_blank" onClick={() => setToggle(false)}>
                  RESUME
                </a>
              </li>
            </ul>
          </motion.div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
